import React from 'react';
import styles from './styles.module.scss';
// Add this import statement
import { InsertedFieldsTooltip } from '../../../../shared/insertFieldsTooltip';

interface PlaceholderItemProps {
  id: string;
  uuid: string;
  title?: string | null;
  isRequired: boolean;
  isActive?: boolean;
  onClick: (uuid: string) => void;
}

const PlaceholderItem: React.FC<PlaceholderItemProps> = ({
  id,
  uuid,
  title,
  isRequired,
  isActive = false,
  onClick,
}) => {
  const tooltipTitle = title || 'Placeholder';

  const tooltipChildren = <span title={title || ''}>{title}</span>;

  return (
    <div
      key={id}
      className={`${styles.placeholderItemContainer} ${isActive ? styles.placeholderItemContainer__active : ''}`}
      onClick={() => onClick(uuid)}
    >
      <div>
        <div className={styles.placeholderItemContainer__title}>
          <InsertedFieldsTooltip title={tooltipTitle} children={tooltipChildren} placement="bottom" />
        </div>
      </div>

      <div className={styles.placeholderItemContainer__requirement}>{isRequired ? 'Required' : 'Optional'}</div>
    </div>
  );
};

export default PlaceholderItem;
